
    var riot = require('riot')
    import { Sayt } from './gb-sayt';
import { SaytTag } from '../tag';
riot.tag2('gb-sayt', '<yield> <div if="{($sayt.queries && $sayt.queries.length) || ($sayt.navigations && $sayt.navigations.length)}"> <gb-sayt-autocomplete></gb-sayt-autocomplete> <gb-sayt-products if="{$sayt.showProducts}"></gb-sayt-products> </div> </yield>', 'gb-sayt.gb-stylish > div,[data-is="gb-sayt"].gb-stylish > div{ display: flex; } gb-sayt.gb-stylish ul,[data-is="gb-sayt"].gb-stylish ul{ list-style: none; margin: 0; padding: 0; } gb-sayt.gb-stylish gb-sayt-link:hover,[data-is="gb-sayt"].gb-stylish gb-sayt-link:hover,gb-sayt.gb-stylish gb-sayt-link.active,[data-is="gb-sayt"].gb-stylish gb-sayt-link.active{ background-color: #f1f1f1; display: block; } gb-sayt.gb-stylish gb-list li,[data-is="gb-sayt"].gb-stylish gb-list li{ margin: 0px; }', '', function(opts) {
    this._mixin(SaytTag, Sayt);
});

    
  


// WEBPACK FOOTER //
// ./src/tags/sayt/gb-sayt.tag.html